import clsx from 'clsx';
import type * as React from 'react';

export type IllustrationCardProps = React.ComponentPropsWithoutRef<'div'> & {
    /** Shadow depth. Defaults to `subtle` (background / chrome cards); use
     * `elevated` for a hero card that needs to read as the foreground. */
    elevation?: 'subtle' | 'elevated';
};

/**
 * Note: ONLY intended for empty-state illustrations.
 *
 * Recurring rounded-md card surface (neutral border + bg-base) used as the
 * hero card, popover, or browser-strip wrapper inside mid-fidelity
 * empty-state illustrations. Skip when a different palette / radius is
 * intentional (e.g. `bg-neutral-surface-subtle`, `rounded-2xl`).
 */
export function IllustrationCard(props: IllustrationCardProps) {
    const { className, children, ...rest } = props;
    return (
        <div
            aria-hidden
            {...rest}
            className={clsx(
                'overflow-hidden rounded-md border border-neutral-subtle bg-base shadow-subtle',
                className
            )}
        >
            {children}
        </div>
    );
}
